import { EnumBase } from 'hay-core-react';
class TarefaAgendadaLogStatusEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.tarefaagendadalog.status.emexecucao',
                'main.tarefaagendadalog.status.sucesso',
                'main.tarefaagendadalog.status.erro',
            ],
            'main.tarefaagendadalog.status.emexecucao'
        );
    }
}

const instance = new TarefaAgendadaLogStatusEnum();
export default instance;
